import React, { useState, useEffect, useCallback } from "react";
import { useForm, FormProvider } from "react-hook-form";
import { DropzoneDialog } from "material-ui-dropzone";
//Material
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import InputLabel from "@material-ui/core/InputLabel";
import { TextField } from "@material-ui/core";
import LinearProgress from "@material-ui/core/LinearProgress";
//Component
import { Modal } from "../../../stories/modal";
import FormControl from "@material-ui/core/FormControl";
import { MaterialUIDatePickers } from "../../../stories/hook-controls/datepicker/datepicker";
//Function
import * as common from "../../../utils/common-function";
import * as alertDialog from "../../../utils/alert";
import * as api from "../api";
import { GetSystemConfig } from "../../master/api";
import { GetUser } from "../../../utils/sessions";

const useStyles = makeStyles((theme) => ({
  labelTitle: {
    marginTop: theme.spacing(0),
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(2),
    minWidth: 150,
  },
  textLabel: {
    color: "#000",
  },
}));

function UserDataImportModal(props) {
  const classes = useStyles();
  const { open, onClose } = props;
  const { data, fetchmain = () => {}, ...otherprops } = props;

  const [loading, setLoading] = useState(false);
  const [openUpload, setOpenUpload] = useState(false);
  const [limitUploadMB, setLimitUploadMB] = useState(50); // defualt 50 MB

  const [file, setfile] = useState([]);
  const [effectiveData, setEffectiveDate] = useState();

  const method = useForm();
  const { clearErrors } = method;

  const fetch = useCallback(async () => {
    const param = {
      CONFIG_NAME: "LIMIT_UPLOAD_USER_DATA",
    };
    const res = await GetSystemConfig(param);
    setLimitUploadMB(res?.INT_VALUE ?? 50);
  }, []);

  useEffect(() => {
    if (!open) return;
    if (typeof data === "undefined") return;
    fetch();
    setEffectiveDate(common.formatDate(new Date()));
    setfile([]);
  }, [data, open]);

  const handleChangeDate = (date) => {
    setEffectiveDate(common.formatDate(date));
  };

  async function upload(files = []) {
    setfile(files[0]);
  }

  const onFileChange = async (event) => {
    const fileData = event.target.files[0];
    if (fileData === undefined) return;
    if (fileData?.size > 2097152) {
      //2,097,152 bytes
      alertDialog.ErrorDialog("File size cannot exceed more than 2MB");
      setfile([]);
      return;
    }
  };

  const validateEffectiveDate = (date) => {
    if (!date || date.trim() === "") {
      alertDialog.ErrorDialog("The Effective date field is required.");
      return false;
    }

    const currentDate = new Date();
    const selectedDate = new Date(date);
    currentDate.setHours(0, 0, 0, 0);
    selectedDate.setHours(0, 0, 0, 0);

    if (selectedDate < currentDate) {
      alertDialog.ErrorDialog("The Effective date cannot be in the past.");
      return false;
    }

    return true;
  };

  const validateFile = (file) => {
    if (!file || file.length === 0) {
      alertDialog.ErrorDialog("Please upload a file.");
      return false;
    }
    return true;
  };

  const onUploadMasterData = async () => {
    clearErrors("EFFECTIVE_DATE");

    // Validate effective date
    if (!validateEffectiveDate(effectiveData)) return;

    // Validate file
    if (!validateFile(file)) return;

    const form = new FormData();
    const payload = {
      ...data,
      EFFECTIVE_DATE: effectiveData,
      USER_ID: GetUser(),
    };

    form.append("file", file);
    form.append("info", JSON.stringify(payload));

    try {
      setLoading(true);

      const res = await api.UploadMasterData(form);
      if (res?.ResultCode === 10) {
        fetchmain();
        onClose();
        alertDialog.inform_success();
      } else {
        alertDialog.ErrorDialog(
          "Error: " + (res.Message || "An unexpected error occurred.")
        );
      }
    } catch (error) {
      console.error("UploadMasterData error:", error);
      alertDialog.ErrorDialog("An error occurred while uploading data.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      {...otherprops}
      onSave={onUploadMasterData}
      title="User Data Import"
      maxWidth="sm"
    >
      <FormProvider {...method}>
        <Grid container spacing={2}>
          <Grid item xs={4}>
            <FormControl variant="outlined" className={classes.labelTitle}>
              <InputLabel className={classes.textLabel}>
                Template Name :{" "}
              </InputLabel>
            </FormControl>
          </Grid>
          <Grid item xs={8}>
            <TextField
              disabled
              id="outlined-full-width"
              fullWidth
              name="TEMPLATE_NAME"
              InputLabelProps={{
                shrink: true,
              }}
              variant="outlined"
              value={data?.TEMPLATE_NAME || ""}
            />
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={4}>
            <FormControl variant="outlined" className={classes.labelTitle}>
              <InputLabel className={classes.textLabel}>Version : </InputLabel>
            </FormControl>
          </Grid>
          <Grid item xs={8}>
            <TextField
              disabled
              id="outlined-full-width"
              fullWidth
              name="VERSION"
              InputLabelProps={{
                shrink: true,
              }}
              variant="outlined"
              value={data?.VERSION || ""}
            />
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={4}>
            <FormControl variant="outlined" className={classes.labelTitle}>
              <InputLabel className={classes.textLabel}>
                Effective Date :{" "}
              </InputLabel>
            </FormControl>
          </Grid>
          <Grid item xs={8}>
            <MaterialUIDatePickers
              name="EFFECTIVE_DATE"
              className={classes.formControl}
              format="dd-MMM-yyyy"
              variant="dialog"
              onChange={handleChangeDate}
              value={effectiveData}
              fullWidth={true}
              disablePast={true}
            />
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={4}>
            <FormControl variant="outlined" className={classes.labelTitle}>
              <InputLabel className={classes.textLabel}>
                Upload File :{" "}
              </InputLabel>
            </FormControl>
          </Grid>
          <Grid item xs={8} className={classes.textXS12}>
            <FormControl variant="outlined" fullWidth={true}>
              <Box display="flex" className="browseFile">
                <TextField
                  disabled
                  id="outlined-full-width"
                  label=""
                  fullWidth
                  name="FILE_NAME"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  variant="outlined"
                  value={file?.name || ""}
                />
                <button
                  onClick={() => {
                    setOpenUpload(true);
                  }}
                >
                  Browse
                </button>
                <input
                  type="file"
                  name="file"
                  onChange={onFileChange}
                  accept=".csv"
                  style={{ display: "none" }}
                />
              </Box>
            </FormControl>
            <DropzoneDialog
              acceptedFiles={[
                ".csv, text/csv, application/csv, text/x-csv, application/x-csv, text/comma-separated-values, text/x-comma-separated-values",
              ]}
              cancelButtonText={"cancel"}
              filesLimit={1}
              submitButtonText={"submit"}
              maxFileSize={limitUploadMB * 1024 * 1024}
              open={openUpload}
              onClose={() => setOpenUpload(false)}
              onSave={(files) => {
                upload(files);
                setOpenUpload(false);
              }}
              showPreviews={true}
              showFileNamesInPreview={true}
            />
          </Grid>
          <Grid item xs={12}>
            {loading && <LinearProgress />}
            {loading && <LinearProgress color="secondary" />}
          </Grid>
        </Grid>
      </FormProvider>
    </Modal>
  );
}
export default UserDataImportModal;
